export default __webpack_public_path__ + "static/toomuch-223c780bf098451141625d0b95e9f9e1.png";